import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/brand";

export default function Testimonials() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative scroll-mt-24 overflow-hidden bg-[#0F172A] py-20 text-white md:py-28"
    >
      <div className="pointer-events-none absolute -top-32 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-[#1E3A8A] blob" />
      <div className="pointer-events-none absolute -bottom-32 right-0 h-80 w-80 rounded-full bg-[#EA580C] blob" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#EA580C]">
            Testimonios
          </span>
          <h2 className="mt-3 font-display text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
            Tutores que confían en CEQVet
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">
            Más de mil mascotas atendidas. Estas son algunas opiniones
            recientes de quienes ya forman parte de nuestra comunidad.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur"
            >
              <Quote className="h-6 w-6 text-[#EA580C]" />
              <div className="mt-3 flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star
                    key={j}
                    className="h-4 w-4 fill-[#EA580C] text-[#EA580C]"
                  />
                ))}
              </div>
              <p className="mt-4 text-sm leading-relaxed text-slate-200">
                "{t.text}"
              </p>
              <div className="mt-5 border-t border-white/10 pt-4">
                <div className="text-sm font-semibold">{t.name}</div>
                <div className="text-xs text-slate-400">{t.pet}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
